module.exports = __webpack_public_path__ + "media/images/flags/16/Niue-bdaa6b789f5134eff30ccdd577e762f8.png";